import { render } from "./CtaTitle.vue?vue&type=template&id=8296d2c0"
import script from "./CtaTitle.vue?vue&type=script&lang=js"
export * from "./CtaTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/modules/CtaTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8296d2c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8296d2c0', __exports__)) {
    api.reload('8296d2c0', __exports__)
  }
  
  module.hot.accept("./CtaTitle.vue?vue&type=template&id=8296d2c0", () => {
    api.rerender('8296d2c0', render)
  })

}


export default __exports__